import React from 'react'
import Banner from '../components/Home/Banner'
import AboutProduct from '../components/Home/AboutProduct'
import Buy from '../components/Home/Buy'
import FAQ from '../components/Home/FAQ'
import Contact from '../components/Home/Contact'
import Footer from '../components/Footer'

const Home = () => {
  return (
    <>
      <Banner />
      <AboutProduct />
      <Buy />
      <FAQ />
      <Contact />
      <Footer />
    </>
  )
}

export default Home
